const BASE_URL = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") ? 
    'http://localhost:5000/databot-app/europe-west1/api'
    :
    process.env.REACT_APP_BASE_URL;

module.exports = {
    BASE_URL
}